import React from 'react';
import { useCanvasStore } from '../../store/canvasStore';
import { useEditorStore } from '../../store/editorStore';

const LayersPanel: React.FC = () => {
  const { shapes } = useCanvasStore();
  const { selectedIds, setSelectedIds } = useEditorStore();

  return (
    <div className="flex-1 min-h-0 overflow-y-auto p-2 mt-2 border-t" style={{ borderColor: '#2e2e40' }}>
      <h3 className="text-xs font-semibold mb-2" style={{ color: '#8888aa' }}>
        Layers
      </h3>
      {shapes.length === 0 ? (
        <p className="text-xs" style={{ color: '#666' }}>
          No elements yet.
        </p>
      ) : (
        <div className="space-y-1">
          {shapes.map((s) => (
            <button
              key={s.id}
              onClick={() => setSelectedIds([s.id])}
              className={`w-full text-left px-2 py-1.5 rounded text-xs truncate ${
                selectedIds.includes(s.id) ? 'bg-[#FF4C4C]/20' : 'hover:bg-white/5'
              }`}
              style={{ color: selectedIds.includes(s.id) ? '#FF4C4C' : '#f0f0f5' }}
            >
              {s.label || s.type || s.id.slice(0, 8)}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LayersPanel;
